<template>
  <Modal v-model="eventsModal" width="700" footer-hide>
    <p slot="header">
      <Icon type="ios-text" />
      <span> {{ eventsModalTitle }}</span>
    </p>
    <p style="margin-bottom: 10px; padding-left: 5px; font-size: 13px">
      <Row>
        <Col span="24" :md="5">
          <b>设备：</b><span>{{ eventsDataSupplement.endpoint }}</span>
        </Col>
        <Col span="24" :md="13">
          <b>指标：</b>
          <span>{{ eventsDataSupplement.metric_name }}</span>
          <span v-show="eventsDataSupplement.metric !== eventsDataSupplement.metric_name"> ({{ eventsDataSupplement.metric }})</span>
        </Col>
        <Col span="24" :md="4">
          <b>触发函数：</b><span>{{ eventsDataSupplement.func }}</span>
        </Col>
        <Col span="24" :md="2">
          <span style="float: right"><a v-on:click="openChartModal">监控图</a></span>
        </Col>
      </Row>
    </p>
    <div v-if="!eventsData.length">
      <Alert show-icon>无数据</Alert>
    </div>
    <div v-else>
      <GeminiScrollbar class="logs-scroll-bar" :style="{height: '650px'}">
        <div v-for="item in eventsData" v-bind:key="item.id">
          <Alert type="success" show-icon v-if="item.status">
            <span><b>OK</b></span>
            <template slot="desc">
              <p></p>
              <p><b>触发：</b>{{ item.cond }}</p>
              <p><b>时间：</b>{{ dateFormat(item.timestamp) }} ({{ daysBetween(item.timestamp) }})</p>
            </template>
          </Alert>
          <Alert type="warning" show-icon v-if="!item.status">
            <span><b>PROBLEM</b></span>
            <template slot="desc">
              <p><b>触发：</b><span v-if="item.cond!=='-1 == -1'">{{ item.cond }}</span><span v-else>{{ noDataView }}</span></p>
              <p><b>时间：</b>{{ dateFormat(item.timestamp) }} ({{ daysBetween(item.timestamp) }})</p>
            </template>
          </Alert>
        </div>
      </GeminiScrollbar>
    </div>
  </Modal>
</template>

<script>
import { getEvents } from '@/api/monitor'
import eventVue from './event.js'
import { getDaysBetween } from '@/libs/timeTools'

export default {
  name: 'alarm-logs-events-modal',
  data () {
    return {
      eventsModal: false,
      eventsModalTitle: '',
      eventsDataSupplement: {},
      eventsData: [],
      noDataView: '监控中断'
    }
  },
  methods: {
    daysBetween (sDate1) {
      return getDaysBetween(sDate1)
    },
    dateFormat (date) {
      function change (t) {
        if (t < 10) {
          return '0' + t
        } else {
          return t
        }
      }
      let d = new Date(date)
      let year = d.getFullYear()
      let month = change(d.getMonth() + 1)
      let day = change(d.getDate())
      let hour = change(d.getHours())
      let minute = change(d.getMinutes())
      let second = change(d.getSeconds())
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    },
    eventsModalOpen (row) {
      let params = {
        event_id: row.id
      }
      getEvents(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.eventsData = result.data
          this.eventsModalTitle = '告警事件列表：' + row.id
          this.eventsDataSupplement.func = row.func
          this.eventsDataSupplement.metric = row.metric
          this.eventsDataSupplement.metric_name = row.metric_name
          this.eventsDataSupplement.endpoint = row.endpoint
          this.eventsModal = true
        } else {
          this.$Notice.error({
            title: '失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    openChartModal () {
      let data = {
        req_data: {
          last: '3600',
          angle: 'counter',
          cf: 'AVERAGE',
          sum: false,
          sumonly: false,
          start: '',
          end: '',
          endpoints: [this.eventsDataSupplement.endpoint],
          counters: [this.eventsDataSupplement.metric]
        },
        title: this.eventsDataSupplement.endpoint
      }
      eventVue.$emit('openChartFun', data)
    }
  }
}
</script>

<style scoped>

</style>
